import QRCode from 'react-qr-code'

/**
 * QR-blok voor een uiting: de code zelf plus de leesbare doel-URL eronder,
 * zodat de gebruiker kan controleren waar de QR naartoe wijst.
 *
 * @param {object} props
 * @param {string} props.url - Absolute impactopen-URL (met scan-markering)
 */
const ImpactQrBlock = ({ url }) => {

    return (
        <div className='impact-qr-block'>
            <QRCode value={url} size={96} />
            <p className='impact-qr-block-url'>{url}</p>
        </div>
    )
}

export default ImpactQrBlock
